import { Form } from "@circle-react-shared/uikit/Form";

const DEFAULT_UNITS = ["px", "rem", "em"];

interface ButtonSliderControlProps {
  isFirstChild?: boolean;
  label: string;
  max?: number;
  min?: number;
  name: string;
  step?: number;
}

export const ButtonSliderControl = ({
  name,
  label,
  min = 0,
  max = 100,
  step = 0.1,
  isFirstChild = false,
}: ButtonSliderControlProps) => (
  <Form.Item
    hideBorder
    hideDescription
    name={name}
    label={label}
    isFirstChild={isFirstChild}
  >
    <Form.SliderWithInput
      name={name}
      min={min}
      max={max}
      step={step}
      units={DEFAULT_UNITS}
    />
  </Form.Item>
);
